import { Mine__factory } from 'public/abi/evm/types';
import { Tokens } from '~/utils/constants';
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';

export default () => {
  const store = useMainStore();
  const { blockchain } = useEnvs();
  const { address } = useWeb3ModalAccount();
  const { getProvider } = useProvider();
  const { currentToken } = storeToRefs(store);

  const minedBalance = ref<bigint[]>([]);
  const isLoading = ref(false);

  // monotonically increasing request id; only latest is allowed to commit
  let reqId = 0;
  let aborted = false;

  async function getMinedBalance(): Promise<void> {
    const myId = ++reqId;
    isLoading.value = true;

    try {
      const tokenSnap = currentToken.value;
      const addrSnap = address.value;

      if (tokenSnap === Tokens.pearl || !addrSnap) {
        if (myId === reqId) minedBalance.value = [];
        return;
      }

      const mineAddress = blockchain.contracts[tokenSnap].addresses.mine;
      if (!mineAddress) throw new Error('No mine address found');

      const mineContract = Mine__factory.connect(mineAddress, getProvider());

      const result = await mineContract.minedData(addrSnap);

      if (!aborted && myId === reqId && tokenSnap === currentToken.value && addrSnap === address.value) {
        minedBalance.value = result;
      }
    } catch (err) {
      if (!aborted && myId === reqId) {
        console.log('err: ', err);
        minedBalance.value = [];
      }
    } finally {
      if (myId === reqId) {
        isLoading.value = false;
      }
    }
  }

  watch(
    [() => currentToken.value, () => address.value],
    () => {
      getMinedBalance();
    },
    { immediate: true }
  );

  onUnmounted(() => {
    aborted = true;
    reqId++;
  });

  return {
    minedBalance,
    getMinedBalance,
    isLoading
  };
};
